import { Component, Mixins } from "vue-property-decorator";
import IndicatorMixin from "@/mixins/http/IndicatorMixin";

@Component
class IndicatorService extends Mixins(IndicatorMixin) {}

export default new IndicatorService();
